<!--
 * @Author: wang dong
 * @Date: 2020-11-07 10:21:49
 * @LastEditTime: 2020-11-07 15:40:38
 * @LastEditors: Please set LastEditors
 * @Description: 一次性产品服务
 * @FilePath: \magiccube-ui\src\views\customer\companyDetail\contractManagementCancelDialog.vue
-->
<template>
<fragment>
    <div v-show="visible" class="back"></div>
    <el-dialog title="合同作废" :visible="visible" @update:visible="v => $emit('update:visible', v)" :modal="false" :append-to-body="true">
        <h1>{{row.customerName}}</h1>
        <avue-form ref="form" v-model="form.data" :option="form.option" />
        <span slot="footer" class="dialog-footer">
            <el-button @click="$emit('update:visible', false)">取 消</el-button>
            <el-button type="primary" @click="ok">确 定</el-button>
        </span>
    </el-dialog>
</fragment>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import { getAgProductBreakUpdate } from "@/api/customer/agProductBreak";
export default {
    props: {
        visible: {
            type: Boolean,
            default: () => false
        },
        // :row="row" @ok="ok"
        row:{
            type: Object,
            default: ()=> ({})
        }
    },
    data() {
        return {
            form: {
                data: {},
                option: {
                    menuBtn: false,
                    column: [{
                        label: '作废原因',
                        prop: 'cancelReason',
                        type: 'textarea',
                        span: 24,
                        showWordLimit: true,
                        maxlength: 150,
                        rules: [{
                            required: true,
                            message: '请输入作废原因',
                            trigger: 'change'
                        }]
                    }]
                }
            }
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'customer'])
    },
    watch: {
        visible(v) {
            if (v) this.load()
        }
    },
    methods: {
        async load() {
            this.form.data = {
                cancelReason:'',
                id: this.row.id,
                isfinish:0,
                contractId:this.row.contractId,
                cancelUser: this.userInfo.user_name
            }
            this.resetFieldsForm('form');

        },
        async ok() {
            if (await this.validateForm('form')) {
                this.$emit('update:visible', false)
                await this.$nextTick()
                const { data:{code,msg} } = await getAgProductBreakUpdate({
                    ...this.filterClone(this.form.data),
                }).finally(()=>this.$emit("ok"));
                if(code===200) this.$message.success(msg)
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
    ::v-deep {
        .el-dialog {
            h1 {
                position: absolute;
                top: 1rem;
                left: 70px;
                font-size: 12px;
                color: #438ffd;
                font-weight: normal;
                margin: auto;
                z-index: 99999;
            }
            .el-dialog__body{
                min-height: 120px;
            }
            .el-dialog__header {
                text-align: left;
            }
        }
    }
}

.back {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 9999;
}
::v-deep{
    .avue-form__group > div {
        height: auto;
    }
}
</style>
